import Backbone from 'backbone'

class Event extends Backbone.Model {

}

export default Event
